import { createClient as supabaseCreateClient } from '@supabase/supabase-js'

// Runtime adapter registry. The CLI push pipeline deliberately strips
// `createClient` before transport (it's a live function, not serializable),
// so every editor surface has to re-attach factories here at load time
// before handing `project` off to the fetch plugin.
//
// Extend this map when the project runtime grows a new data backend —
// adding an entry is the single change required; every editor surface
// picks it up automatically because they all call `attachDbAdapters`.
const ADAPTER_FACTORIES = Object.freeze({
  supabase: supabaseCreateClient
})

/**
 * Attach runtime `createClient` factories onto `project.db` and
 * `project.fetch`. Idempotent — safe to call more than once on the same
 * project; sentinel flag prevents re-assignment. Mutates in place and
 * returns `project` for chaining.
 *
 * @param {object} project — loaded project data (from getProjectData).
 * @returns {object} same project, with adapters wired.
 */
export function attachDbAdapters (project) {
  if (!project) return project
  attachOne(project.db)
  attachOne(project.fetch)
  return project
}

function attachOne (cfg) {
  if (!cfg || cfg.__adapterAttached) return
  const factory = ADAPTER_FACTORIES[cfg.adapter]
  // Incomplete configs (missing adapter or url) are left bare — the fetch
  // plugin's adapter resolver will surface the missing field.
  if (!factory || !cfg.url) return
  cfg.createClient = factory
  cfg.__adapterAttached = true
}
